export default [
  /* =============================首页================================= */

  /* =============================资讯================================= */
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component: () => import('../views/news/newsDetail'),
    meta: {
      title: '资讯详情',
      backPath: 'news',
      hideTabBar: true
    }
  },
  /* =============================众筹项目================================= */
  {
    path: '/crowdfundDetail',
    name: 'crowdfundDetail',
    component: () => import('@/views/crowdfunding/crowdfundDetail'),
    meta: {
      title: '众筹项目详情'
    }
  },
  {
    path: '/fill',
    name: 'fill',
    component: () => import('../views/crowdfunding/fill'),
    meta: {
      title: '学生信息填报',
      hideTabBar: true
    }
  },
  /* =============================志愿者服务================================= */
  {
    path: '/volunteerDetail',
    name: 'volunteerDetail',
    component: () => import('@/views/volunteerService/volunteerDetailNew'),
    meta: {
      title: '志愿者服务详情'
    }
  },
  {
    path: '/signUp',
    name: 'signUp',
    component: () => import('@/views/volunteerService/signUpNew'),
    meta: {
      title: '志愿者报名'
    }
  },
  {
    path: '/records',
    name: 'records',
    component: () => import('@/views/volunteerService/volunteerRecords'),
    meta: {
      title: '志愿者记录'
    }
  },
  {
    path: '/signIn',
    name: 'signIn',
    component: () => import('@/views/volunteerService/volunteerSignIn'),
    meta: {
      title: '志愿者注册'
    }
  },
  /* =============================我的================================= */
  {
    path: "/accountSetting",
    name: "accountSetting",
    component: () => import("@/views/mine/accountSetting.vue"),
    meta: {
      title: "基本信息",
    },
  },
  {
    path: "/notice",
    name: "notice",
    component: () => import("@/views/mine/notice.vue"),
    meta: {
      title: "消息通知",
    },
  },
  {
    path: "/myCollect",
    name: "myCollect",
    component: () => import("@/views/mine/myCollect.vue"),
    meta: {
      title: "我的收藏",
    },
  },
  {
    path: "/agreementThat",
    name: "agreementThat",
    component: () => import("@/views/mine/agreementThat.vue"),
    meta: {
      title: "隐私政策",
    },
  },
  {
    path: "/registerProcess",
    name: "registerProcess",
    component: () => import("@/views/mine/registerProcess.vue"),
    meta: {
      title: "注册进度查询",
    },
  },
  {
    path: "/addUserOtherIdentity",
    name: "addUserOtherIdentity",
    component: () => import("@/views/mine/addUserOtherIdentity.vue"),
    meta: {
      title: "添加身份",
    },
  },
  {
    path: "/myReport",
    name: "myReport",
    component: () => import("@/views/mine/myReport.vue"),
    meta: {
      title: "我的上报",
    },
  },
  {
    path: "/myReport-detail",
    name: "myReport-detail",
    component: () => import("@/views/mine/myReportDetail.vue"),
    meta: {
      title: "我的上报详情",
    },
  },
  {
    path: "/myApproval",
    name: "myApproval",
    component: () => import("@/views/mine/myApproval.vue"),
    meta: {
      title: "我的审批",
    },
  },
  {
    path: "/myApproval-detail",
    name: "myApproval-detail",
    component: () => import("@/views/mine/myApprovalDetail.vue"),
    meta: {
      title: "我的审批详情",
    },
  },
  {
    path: "/myReceipt",
    name: "myReceipt",
    component: () => import("@/views/mine/myReceipt.vue"),
    meta: {
      title: "我的签收",
    },
  },
  {
    path: "/myReceipt-detail",
    name: "myReceipt-detail",
    component: () => import("@/views/mine/myReceiptDetail.vue"),
    meta: {
      title: "我的签收详情",
    },
  },
  {
    path: "/myCard",
    name: "myCard",
    component: () => import("@/views/mine/myCard.vue"),
    meta: {
      title: "我的结对卡",
    },
  },
  {
    path: "/myCard-detail",
    name: "myCard-detail",
    component: () => import("@/views/mine/myCardDetail.vue"),
    meta: {
      title: "我的结对卡详情",
    },
  },
  {
    path: "/donationProject",
    name: "donationProject",
    component: () => import("@/views/mine/donationProject.vue"),
    meta: {
      title: "捐赠项目",
    },
  },
  {
    path: "/donationProjectDetail",
    name: "donationProjectDetail",
    component: () => import("@/views/mine/donationProjectDetail.vue"),
    meta: {
      title: "捐赠项目详情",
    },
  },
  {
    path: "/pairingCard",
    name: "pairingCard",
    component: () => import("@/views/mine/pairingCard.vue"),
    meta: {
      title: "结对卡",
    },
  },
  {
    path: "/pairingCardDetail",
    name: "pairingCardDetail",
    component: () => import("@/views/mine/pairingCardDetail.vue"),
    meta: {
      title: "结对卡详情",
    },
  },
  {
    path: "/VolunteerEditor",
    name: "VolunteerEditor",
    component: () => import("@/views/mine/volunteerEditor.vue"),
    meta: {
      title: "志愿者信息",
    },
  },
  {
    path: "/volunteerApproval",
    name: "volunteerApproval",
    component: () => import("@/views/mine/volunteerApproval.vue"),
    meta: {
      title: "我申请的活动",
    },
  },
  {
    path: "/volunteerJoin",
    name: "volunteerJoin",
    component: () => import("@/views/mine/volunteerJoin.vue"),
    meta: {
      title: "我参与的活动",
    },
  },
  {
    path: "/myCertificate",
    name: "myCertificate",
    component: () => import("@/views/mine/myCertificate.vue"),
    meta: {
      title: "我的志愿者证书",
    },
  },
]
